import GameSignals from '@/signals/GameSignals'
import { BaseChildState } from '@stateMachine/BaseChildState'
import Facade from '@/Facade'

export class BigWinState extends BaseChildState {

    public canTrigger(): boolean {
        return this._model.bigWinLevel !== null
    }

    public begin() {
        GameSignals.showBigWinComplete.connect(this.end)
        GameSignals.showBigWin.connect(this.onShowBigWin)

        let winAmount: number = this._model.spinData.base_win_currency
        if (this._model.winCounter.totalWin + winAmount > 10000 * this._model.currentBet) {
            winAmount = (10000 * this._model.currentBet) - this._model.winCounter.totalWin
        }

        GameSignals.bigWinPresentation.emit({
            win: winAmount,
            bet: this._model.currentBaseBet,
            bigWinLevel: this._model.bigWinLevel,
        })
    }

    private onShowBigWin = () => {
        Facade.stage.addListener('pointerdown', this.onSkipBigWin)
        Facade.stage.interactive = true

        GameSignals.stopButtonClicked.connect(this.onSkipBigWin)
        GameSignals.spinButtonClicked.connect(this.onSkipBigWin)
    }

    private onSkipBigWin = () => {
        GameSignals.skipBigWin.emit()
    }

    public cleanUp() {
        Facade.stage.removeListener('pointerdown', this.onSkipBigWin)
        Facade.stage.interactive = false

        GameSignals.stopButtonClicked.disconnect(this.onSkipBigWin)
        GameSignals.spinButtonClicked.disconnect(this.onSkipBigWin)
        GameSignals.showBigWinComplete.disconnect(this.end)
        GameSignals.showBigWin.disconnect(this.onShowBigWin)
    }
}
